import styled from 'styled-components';

export const ContainerResume = styled.div`
  background-color: #fafafa;
  width: 100vw;
  display: flex;
  align-items: center;
  flex: none;
  flex-direction: column;
`;

export const ExpandResumePurchase = styled.div`
  display: flex;
  flex: none;
  font-family: 'Libre Franklin', sans-serif;
  width: 89.333vw;
  align-items: center;
  background-color: #fafafa;
  padding-top: 3vw;
  p {
    font-weight: 400;
    font-size: 3.733vw;
    background-color: transparent;
  }
`;

export const CartIcon = styled.img`
  width: 3.885vw;
  height: 3.466vw;
  margin: 0 1.52vw 0 0;
`;

export const ArrowUpIcon = styled.img<{ transform: string }>`
  width: 3.8vw;
  height: 4.424vw;
  margin: 0 0 0 34vw;
  transform: ${(props) => props.transform};
`;

export const PurchaseCheckout = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  background-color: #fafafa;
`;

export const ImageCourse = styled.img<{ backImage: string }>`
  display: flex;
  flex: none;
  background-image: url(${(props) => props.backImage});
  background-size: cover;
  border-radius: 2.666vw;
  background-position: center;
  position: relative;
  height: 29.333vw;
  margin-top: 4.533vw;
  width: 89.333vw;
  background-repeat: no-repeat;
  margin-bottom: 5.33vw;
  border: none;
`;

export const ContainerTotal = styled.div`
  display: flex;
  flex: none;
  width: 89.333vw;
  align-items: flex-end;
  font-family: 'Libre Franklin', sans-serif;
  justify-content: space-between;
  margin: 3.333vw 0 3.333vw 0;
  background-color: #fafafa;
  h4 {
    font-size: 3.733vw;
    font-weight: 400;
    background-color: transparent;
  }
`;

export const ContainerValues = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 0.266vw;
  font-family: 'Libre Franklin', sans-serif;
  align-items: flex-end;
  background-color: transparent;
  span {
    text-decoration: line-through;
    font-size: 3.733vw;
    font-weight: 400;
    background-color: transparent;
  }
  p {
    font-size: 5.866vw;
    font-weight: 700;
    background-color: transparent;
  }
`;

export const GrayLine = styled.div`
  height: 1px;
  background-color: #c7c7c7;
  width: 89.3vw;
  margin-top: 1px;
`;
